// Per-integration outcome of a descriptor / ARN suggestions pull, shared by Alerts
// onboarding and Deflect setup Step 3 (CHA1-4909).

export const INTEGRATION_PROVIDER = Object.freeze({
  SHOPIFY: "shopify",
  STRIPE: "stripe"
})

export const INTEGRATION_ERROR = Object.freeze({
  TOKEN_NEEDS_RECONNECT: "token_needs_reconnect"
})

const INTEGRATION_LABELS = {
  [INTEGRATION_PROVIDER.SHOPIFY]: "Shopify",
  [INTEGRATION_PROVIDER.STRIPE]: "Stripe"
}

const INTEGRATION_ERROR_TEXTS = {
  [INTEGRATION_ERROR.TOKEN_NEEDS_RECONNECT]: "reconnect the integration to get suggestions."
}

const DEFAULT_INTEGRATION_ERROR_TEXT =
  "suggestions are unavailable right now. You can enter values manually."

export const getIntegrationLabel = (provider) => INTEGRATION_LABELS[provider] || provider

// An i18n key: pass it through t().
export const getIntegrationErrorText = (error) =>
  INTEGRATION_ERROR_TEXTS[error] ?? DEFAULT_INTEGRATION_ERROR_TEXT
